// 개발요청 상세 — 진행 단계 막대 · «할 일» 상자 · ① 부서 작성 · ② 검토 · ③ 진행·완료(+완료 확인) + 통합 · 첨부 · 추가 요청 · 메모 · 이력.
// 🔴 모든 글은 글자로만 그린다(dangerouslySetInnerHTML 금지 · 줄바꿈은 white-space: pre-wrap).
// 🔴 단추를 보일지는 서버 값으로만 정한다 — 요청 단위는 item.can.*(D2a), 첨부·메모 행 단위는 행의 can_delete(D3a).
//    이 화면은 me.is_ax·부서·상태 글자로 권한을 다시 계산하지 않는다(me.is_ax 는 «AX 내부 메모» 체크 · AX 만 쓰는 칸
//    (D5a · 서버 review 등이 require_ax) — ②③ 카드의 «고치기» · ① 머리의 공개 범위·요청자 연결 · «할 일»의 AX 항목에만 쓴다).
//    쓰기(D4b): 고치기 = can.edit_part1 · 철회 = can.withdraw · 완료 확인 = can.confirm · 첨부 올리기 = can.attach · 메모 쓰기 = can.comment
//    · 추가 요청(2판 V3) = can.ask · 답하기 = can.answer_ask.
// 2판 V3: 오른쪽 «AX 검토» 칸을 없앴다 — 상세는 AX·비AX 같은 폭이고, AX 는 ②③ 카드의 «고치기»로 그 자리에서 고친다
//    (고치기 상태의 주인은 상세 — editing). 요청자에게는 빈 «② 검토» 칸을 그리지 않는다(«아직 검토 전이에요»).
// 첨부(2판 V2): 목록의 주인은 상세다 — files 를 한 번 불러 «지금 하는 방식»·«원하는 기능»·«참고자료» 줄 아래(칸 첨부)와
//    «기타 첨부»(칸 없음) · 추가 요청 기록(ask_id 로 묶은 답 첨부)에 나눠 준다. 칸 첨부는 여기서 지우지 않는다(고치기 창에서).
// 🔴 새 요소(진행 단계 막대·«할 일» 상자)에 role="status" 를 쓰지 않는다 — 그것은 «불러오는 중…» 같은 잠깐 표시 몫이다.
// AX실 담당자: ② 카드의 «AX 담당자» 줄(요청자는 값이 있을 때만) · 고르는 상자(DevRequestAssignee)는 AX 이고 ② 고치기 중이 아닐 때만.
// DEV 확인 계정: «할 일» 상자 바로 아래 독립 줄(DevRequestQaAccount · AX 만) — 상태·철회·요청자 판정은 그 안에서(회수 길을 막지 않게).
// AI 종합 판단(P2b): ② 카드 안 «AI 종합 판단» 묶음(DevRequestAiReport · AX 만 · ② 고치는 중에도 · 단추 없음 — 결정은 사람이) — 부르기·문구는 그 안에서.
// 머리 줄 «‹ 이전 / 다음 ›»(J/K) · «크게 보기» — 목록 화면이 nav·onToggleExpand 를 줄 때만 그린다(상세만 그리면 지금과 같다).
//    넘기기 전 고치던 값이 있으면 «고치던 내용을 버릴까요?»(다른 카드로 옮길 때와 같은 규칙).
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { devreqAPI } from '../../api/client';
import { confirmDialog } from '../../components/AppDialog';
import { COLORS, btn, input as inputStyle } from '../../utils/uiStyles';
import { fmtKstDateTime, parseServerUtc } from '../../utils/kstTime';
import DevRequestAiReport from './DevRequestAiReport';
import DevRequestAssignee from './DevRequestAssignee';
import DevRequestAsks, { DevRequestAskControls, asksSectionId, openAskOf } from './DevRequestAsks';
import DevRequestComments from './DevRequestComments';
import {
  FIELD_FILE_NAMES, FieldFiles, dropUrl, makeUrl, saveDevreqFile, useFileThumbs,
} from './DevRequestAttachField';
import DevRequestFiles from './DevRequestFiles';
import DevRequestQaAccount from './DevRequestQaAccount';
import DevRequestReviewPanel, { DevRequestPart1Tools, WITHDRAWN_NOTICE } from './DevRequestReviewPanel';
import {
  AI_REVIEWER, ASKED_BY_AI, ASKED_BY_REVIEWER, EMPTY, HOLD_DECISIONS, MASKED_NOTICE, MASKED_TITLE, STATUSES, aiScreenView, decisionBadge,
  errorText, eventActionLabel, fmtDay, historyDetail, statusBadge, text, usageLinkKind,
} from './devreqLabels';

const WITHDRAW_CONFIRM = '철회하면 되돌릴 수 없습니다. 이 요청은 부서 건수에서 빠집니다.';
const CONFIRM_NOTE_MAX = 500;   // = devreq_rules.CONFIRM_NOTE_MAX
const FILES_LOAD_FAILED = '첨부 목록을 불러오지 못했습니다.';
const FILE_DOWNLOAD_FAILED = '파일을 내려받지 못했습니다.';
const REVIEW_SAVE_FAILED = '검토를 저장하지 못했습니다.';
const DISCARD_EDIT = '고치던 내용을 버릴까요?';
const NOT_REVIEWED = '아직 검토 전이에요';
const ANSWER_EXCERPT = 80;
const READ_MAX_W = '960px';   // 크게 보기의 읽기 폭 상한
// J/K 를 막는 열린 창 — 🔴 aria-hidden="true" 는 빼야 한다(닫힌 MobileDrawer 는 DOM 에 남아 있다).
const OPEN_MODAL = '[aria-modal="true"]:not([aria-hidden="true"]), [role="alertdialog"]:not([aria-hidden="true"])';
// J = 다음(1) · K = 이전(-1) · 그 밖 0. 한글 입력 상태(key 가 «ㅓ» 등)를 위해 event.code 를 먼저 본다.
const navKeyDir = (event) => {
  if (event.code === 'KeyJ') return 1;
  if (event.code === 'KeyK') return -1;
  if (event.key === 'j' || event.key === 'J') return 1;
  if (event.key === 'k' || event.key === 'K') return -1;
  return 0;
};

// 묶음 머리 색 — 엑셀 양식과 같은 계열(① 파랑 · ② 주황 · ③ 초록).
const PART_COLORS = {
  part1: { background: '#dbeafe', color: '#1d4ed8', border: '#93c5fd' },
  part2: { background: '#ffedd5', color: '#c2410c', border: '#fdba74' },
  part3: { background: '#dcfce7', color: '#15803d', border: '#86efac' },
};
const valueStyle = { margin: 0, fontSize: '13px', color: COLORS.text, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', minWidth: 0 };
const labelStyle = { margin: 0, fontSize: '12px', color: COLORS.textSub, fontWeight: 600 };
const smallBadge = (background, color) => ({
  display: 'inline-block', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, background, color, whiteSpace: 'nowrap',
});
const has = (value) => value !== null && value !== undefined && value !== '';

// 칸 목록 → <dl>. rows = [[이름, 값(글자 또는 요소)]].
function Fields({ rows }) {
  return (
    <dl style={{ display: 'grid', gridTemplateColumns: 'minmax(84px, 120px) minmax(0, 1fr)', gap: '8px 12px', margin: 0, padding: '12px 14px' }}>
      {rows.map(([label, value]) => (
        <div key={label} style={{ display: 'contents' }}>
          <dt style={labelStyle}>{label}</dt>
          <dd style={valueStyle}>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

// 묶음 — 머리 줄(h3 + 작은 단추들 · 단추는 h3 밖) · 칸 목록(rows 가 없으면 안 그린다) · 그 밖(children).
function Part({ tone, title, rows, actions, children }) {
  const c = PART_COLORS[tone];
  return (
    <section aria-label={title} style={{ border: `1px solid ${c.border}`, borderRadius: '10px', overflow: 'hidden', marginBottom: '12px', background: COLORS.surface }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', padding: '6px 14px', minHeight: '34px', boxSizing: 'border-box', background: c.background, color: c.color }}>
        <h3 style={{ margin: 0, flex: '1 1 auto', fontSize: '13px', fontWeight: 700 }}>{title}</h3>
        {actions}
      </div>
      {rows && rows.length > 0 && <Fields rows={rows} />}
      {children}
    </section>
  );
}

// 사용 위치 — https:// 는 새 탭 · 앱 안 경로는 같은 탭 · 그 밖은 링크로 만들지 않는다(서버가 400 으로 막지만 화면도 한 번 더).
export function UsageLocation({ value }) {
  const kind = usageLinkKind(value);
  if (kind === 'external') {
    return <a href={value} target="_blank" rel="noopener noreferrer" style={{ color: COLORS.primaryDark, overflowWrap: 'anywhere' }}>{value}</a>;
  }
  if (kind === 'internal') {
    return <Link to={value} style={{ color: COLORS.primaryDark, overflowWrap: 'anywhere' }}>{value}</Link>;
  }
  return <span>{text(value)}</span>;
}

// 요청 단위 작업 자리 — 서버가 준 can 을 **그대로** 받는다(받은 값은 data-* 로도 남긴다).
//   고치기 = can.edit_part1 · 철회 = can.withdraw (완료 확인 = can.confirm 은 ③ 묶음 안 · 첨부 = can.attach · 메모 = can.comment 는 각 묶음 안).
export function DevRequestActions({ can, requestId, onEdit, onChanged }) {
  const c = can || {};
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => { aliveRef.current = false; };
  }, []);

  const withdraw = async () => {
    if (busy || !(await confirmDialog(WITHDRAW_CONFIRM))) return;
    setBusy(true);
    setError('');
    try {
      await devreqAPI.withdraw(requestId);
      if (aliveRef.current) onChanged?.();
    } catch (err) {
      const message = await errorText(err, '철회하지 못했습니다.');
      if (aliveRef.current) setError(message);
    } finally {
      if (aliveRef.current) setBusy(false);
    }
  };

  const showEdit = c.edit_part1 === true;
  const showWithdraw = c.withdraw === true;
  return (
    <div
      data-testid="devreq-actions"
      data-can-edit-part1={String(c.edit_part1 === true)}
      data-can-withdraw={String(c.withdraw === true)}
      data-can-confirm={String(c.confirm === true)}
      data-can-attach={String(c.attach === true)}
      data-can-comment={String(c.comment === true)}
    >
      {(showEdit || showWithdraw) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
          {showEdit && <button type="button" onClick={() => onEdit?.()} style={btn('accent', 'sm')}>고치기</button>}
          {showWithdraw && <button type="button" onClick={withdraw} disabled={busy} style={btn('danger', 'sm')}>철회</button>}
        </div>
      )}
      {error && <div role="alert" style={{ marginBottom: '12px', padding: '8px 12px', borderRadius: '8px', background: COLORS.dangerSoft, color: COLORS.dangerText, fontSize: '13px' }}>{error}</div>}
    </div>
  );
}

// 완료 확인(③ 묶음 안) — item.can.confirm 일 때만 그린다(서버가 «테스트·완료 + 부서 작성자 또는 요청자 + 미철회» 로 계산 · AX 라서 참이 되지 않는다).
//   «확인» 은 바로 · «수정 필요» 는 메모 1~500자 필수.
//   이미 답했으면(2판 V4) 두 단추 대신 «내 답: … · 시각» + «답 바꾸기» — 누르면 두 단추가 펼쳐지고 «그대로 두기»로 접는다.
//   (메모는 «요청자 확인» 줄이 이미 보여 주므로 «내 답» 줄에 다시 쓰지 않는다.)
function ConfirmBox({ item, onChanged }) {
  const [needFix, setNeedFix] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [changing, setChanging] = useState(false);   // 답한 뒤 «답 바꾸기»로 두 단추를 펼쳤는가
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => { aliveRef.current = false; };
  }, []);

  // 답한 시각 — 이력(새것부터)의 첫 완료 확인 줄.
  const answeredAt = (Array.isArray(item.events) ? item.events : []).find((ev) => ev.action === 'confirm')?.at;

  const send = async (state) => {
    if (busy) return;
    const body = state === '수정 필요' ? { state, note: note.trim() } : { state };
    setBusy(true);
    setError('');
    try {
      await devreqAPI.confirm(item.id, body);
      if (!aliveRef.current) return;
      // 상자는 key 가 요청 id 라 상세를 다시 읽어도 다시 마운트되지 않는다 — 펼침은 여기서 닫는다(실패면 펼친 채).
      setNeedFix(false);
      setNote('');
      setChanging(false);
      onChanged?.();
    } catch (err) {
      const message = await errorText(err, '완료 확인을 보내지 못했습니다.');
      if (aliveRef.current) setError(message);
    } finally {
      if (aliveRef.current) setBusy(false);
    }
  };

  // 펼침 — 아직 답이 없거나 «답 바꾸기»를 눌렀을 때만 두 단추와 «수정 필요» 메모 묶음을 그린다.
  const open = !item.confirm_state || changing;
  const startChange = () => {
    setChanging(true);
    setNeedFix(false);
    setNote('');
    setError('');
  };
  const keepAnswer = () => {
    setChanging(false);
    setNeedFix(false);
    setNote('');
    setError('');
  };

  const noteReady = note.trim().length >= 1 && !busy;
  return (
    <div role="group" aria-label="완료 확인" style={{ padding: '10px 14px', borderTop: `1px solid ${PART_COLORS.part3.border}` }}>
      <div style={{ ...labelStyle, marginBottom: '6px' }}>써 보신 뒤 «확인» 또는 «수정 필요»로 답해 주세요.</div>
      {item.confirm_state && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: open ? '8px' : 0 }}>
          <span style={{ fontSize: '13px', fontWeight: 700, color: COLORS.text }}>
            {`내 답: ${item.confirm_state}${answeredAt ? ` · ${fmtKstDateTime(answeredAt)}` : ''}`}
          </span>
          {changing ? (
            <button type="button" onClick={keepAnswer} disabled={busy} style={btn('secondary', 'sm')}>그대로 두기</button>
          ) : (
            <button type="button" onClick={startChange} disabled={busy} style={btn('secondary', 'sm')}>답 바꾸기</button>
          )}
        </div>
      )}
      {open && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          <button type="button" onClick={() => send('확인')} disabled={busy} style={btn('primary', 'sm')}>확인</button>
          <button type="button" onClick={() => setNeedFix(true)} disabled={busy} style={btn('secondary', 'sm')}>수정 필요</button>
        </div>
      )}
      {open && needFix && (
        <div style={{ marginTop: '8px' }}>
          <textarea aria-label="수정 필요 메모" value={note} maxLength={CONFIRM_NOTE_MAX} rows={3}
            onChange={(e) => setNote(e.target.value)} placeholder="무엇을 고쳐야 하는지 적어 주세요(필수)"
            style={{ ...inputStyle, resize: 'vertical', fontSize: '13px' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
            <span style={{ fontSize: '11px', color: COLORS.textSub }}>{`${note.length}/${CONFIRM_NOTE_MAX}`}</span>
            <button type="button" onClick={() => { setNeedFix(false); setNote(''); }} disabled={busy}
              style={{ ...btn('secondary', 'sm'), marginLeft: 'auto' }}>취소</button>
            <button type="button" onClick={() => send('수정 필요')} disabled={!noteReady}
              style={{ ...btn('primary', 'sm'), opacity: noteReady ? 1 : 0.5 }}>보내기</button>
          </div>
        </div>
      )}
      {error && <div role="alert" style={{ marginTop: '8px', fontSize: '12px', color: COLORS.dangerText }}>{error}</div>}
    </div>
  );
}

function MergeInfo({ item }) {
  const parent = item.merged_into;
  const children = Array.isArray(item.merged_children) ? item.merged_children : [];
  if (!parent && children.length === 0) return null;
  return (
    <section aria-label="통합" style={{ border: `1px solid ${COLORS.border}`, borderRadius: '10px', padding: '10px 14px', marginBottom: '12px', background: COLORS.surface, fontSize: '13px' }}>
      {parent && (
        <div>
          <span style={labelStyle}>통합 대상 </span>
          <span>→ {text(parent.req_no)}</span>{' '}
          {parent.status && <span style={statusBadge(parent.status)}>{parent.status}</span>}
        </div>
      )}
      {children.length > 0 && (
        <div style={{ marginTop: parent ? '8px' : 0 }}>
          <div style={labelStyle}>이 요청으로 통합된 요청 {children.length}건</div>
          <ul style={{ margin: '6px 0 0', paddingLeft: '18px' }}>
            {children.map((child) => (
              <li key={child.id} style={{ overflowWrap: 'anywhere' }}>
                {text(child.req_no)} · {child.masked ? `🔒 ${MASKED_TITLE}` : text(child.title)}
                {child.withdrawn ? ' · 철회' : ''}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}

// 크게 보기 — 열 때 닫기 단추에 초점 · Esc·바깥 누르기로 닫힘(초점은 누른 썸네일로 돌아간다 — 부모가 돌려준다).
function ImageViewer({ file, url, onClose }) {
  const closeRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onCloseRef.current();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  // 받은 blob 주소를 그 이름으로 저장한다(다시 내려받지 않는다 · 주소는 상세가 갖고 있다).
  const save = () => {
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name || 'attachment';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div
      role="presentation"
      onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px', background: 'rgba(17,24,39,.7)',
      }}
    >
      <div role="dialog" aria-modal="true" aria-label={`${file.name} 크게 보기`}
        style={{ maxWidth: '100%', maxHeight: '100%', display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', borderRadius: '12px', background: COLORS.surface }}>
        <img src={url} alt={file.name} style={{ display: 'block', maxWidth: 'min(90vw, 1200px)', maxHeight: '75vh', objectFit: 'contain' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ flex: 1, minWidth: 0, fontSize: '13px', color: COLORS.text, overflowWrap: 'anywhere' }}>{file.name}</span>
          <button type="button" onClick={save} style={btn('secondary', 'sm')}>내려받기</button>
          <button type="button" ref={closeRef} aria-label="크게 보기 닫기" onClick={onClose} style={btn('primary', 'sm')}>닫기</button>
        </div>
      </div>
    </div>
  );
}

// 진행 단계 막대 — 접수 → 검토 → 대기 → 개발 중 → 테스트 → 완료(서버 STATUSES 순서). 지금 단계만 진하게(aria-current="step")
//   · 지난 단계는 옅게 · 철회면 막대 대신 «철회됨». 휴대폰(compact)은 점 + 지금 단계 이름만.
function StageBar({ item, compact }) {
  if (item.withdrawn) return <span style={smallBadge('#f3f4f6', COLORS.textSub)}>철회됨</span>;
  const at = STATUSES.indexOf(item.status);
  if (compact) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        <ol aria-label="진행 단계" style={{ display: 'flex', gap: '3px', listStyle: 'none', margin: 0, padding: 0 }}>
          {STATUSES.map((s, i) => {
            let background = COLORS.border;
            if (i === at) background = statusBadge(s).color;
            else if (i < at) background = COLORS.textMuted;
            return (
              <li key={s} aria-label={s} aria-current={i === at ? 'step' : undefined} title={s}
                style={{ width: i === at ? '10px' : '7px', height: i === at ? '10px' : '7px', borderRadius: '999px', background }} />
            );
          })}
        </ol>
        {at >= 0 && <span style={statusBadge(item.status)}>{item.status}</span>}
      </div>
    );
  }
  return (
    <ol aria-label="진행 단계" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px', listStyle: 'none', margin: 0, padding: 0 }}>
      {STATUSES.map((s, i) => {
        const current = i === at;
        const style = current
          ? { ...statusBadge(s), fontSize: '12px' }
          : {
            display: 'inline-block', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', whiteSpace: 'nowrap',
            border: `1px solid ${COLORS.border}`, color: i < at ? COLORS.textMuted : COLORS.textSub, opacity: i < at ? 0.6 : 1,
          };
        return (
          <li key={s} aria-current={current ? 'step' : undefined} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            {i > 0 && <span aria-hidden="true" style={{ color: COLORS.textMuted, fontSize: '10px' }}>›</span>}
            <span style={style}>{s}</span>
          </li>
        );
      })}
    </ol>
  );
}

// «할 일» 상자 — 맞는 항목 중 맨 위 하나만(노란 바탕 · role="status" 아님).
function TodoBox({ todo, error }) {
  if (!todo) return null;
  return (
    <section aria-label="할 일" style={{ marginBottom: '12px', padding: '10px 12px', borderRadius: '10px', background: COLORS.warnSoft, border: '1px solid #fde68a' }}>
      <div style={{ fontSize: '13px', fontWeight: 700, color: COLORS.text, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{todo.title}</div>
      {todo.body && (
        <p style={{ margin: '4px 0 0', fontSize: '13px', color: COLORS.text, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{todo.body}</p>
      )}
      {todo.action && <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>{todo.action}</div>}
      {error && <div role="alert" style={{ marginTop: '6px', fontSize: '12px', color: COLORS.dangerText }}>{error}</div>}
    </section>
  );
}

// AX 이력 — 요청자 답 뒤에 AX 가 무엇이든 손댔는가(그러면 «요청자가 추가 요청에 답했어요»를 내린다).
//   일반 메모(comment)는 쓴 사람을 가를 수 없어 세지 않는다 · update 는 ① 글 고치기도 쌓이므로 검토 칸·요청자 연결·담당자 지정만 센다.
const AX_ACTIONS = ['decide', 'merge', 'status', 'visibility', 'comment_internal'];
const AX_UPDATE_FIELDS = ['priority', 'plan_start', 'plan_end', 'detail_state', 'done_on', 'usage_location', 'requester_id', 'assignee'];
const AX_ASK_FIELDS = ['add', 'cancel'];
const isAxEvent = (ev) => AX_ACTIONS.includes(ev.action)
  || (ev.action === 'update' && AX_UPDATE_FIELDS.includes(ev.field))
  || (ev.action === 'ask' && AX_ASK_FIELDS.includes(ev.field));
function axActedAfter(events, at) {
  const since = parseServerUtc(at);
  if (!since) return false;
  return (Array.isArray(events) ? events : []).some((ev) => {
    const when = parseServerUtc(ev.at);
    return when !== null && when.getTime() > since.getTime() && isAxEvent(ev);
  });
}
const excerpt = (value) => {
  if (!value) return '(첨부로 답했어요)';
  const s = String(value);
  return s.length > ANSWER_EXCERPT ? `${s.slice(0, ANSWER_EXCERPT)}…` : s;
};

function History({ events }) {
  if (!Array.isArray(events) || events.length === 0) return null;
  return (
    <details style={{ border: `1px solid ${COLORS.border}`, borderRadius: '10px', padding: '8px 14px', marginBottom: '12px', background: COLORS.surface }}>
      <summary style={{ cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>이력 ({events.length})</summary>
      <ul style={{ listStyle: 'none', margin: '8px 0 0', padding: 0 }}>
        {/* 이력에는 id 가 없다 — 서버가 새것부터 고정 순서로 주고 화면이 순서를 바꾸지 않으므로 순번을 키에 섞는다. */}
        {events.map((ev, i) => (
          <li key={`${ev.at || ''}-${i}`} style={{ fontSize: '12px', padding: '6px 0', borderTop: i ? `1px solid ${COLORS.borderSoft}` : 'none', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
            <span style={{ color: COLORS.textSub }}>{fmtKstDateTime(ev.at) || EMPTY}</span>
            {/* AI 시스템 계정이 남긴 줄(서버 actor_is_ai)은 계정 이름 대신 «AI 검토» */}
            {' · '}{ev.actor_is_ai === true ? AI_REVIEWER : text(ev.actor_name)}{' · '}{eventActionLabel(ev.action, ev.field)}
            {/* 칸·값 — 확인 칸 한글 이름·비움 줄의 작성자는 historyDetail(devreqLabels) */}
            {historyDetail(events, i)}
          </li>
        ))}
      </ul>
    </details>
  );
}

// nav = { onPrev, onNext, label } — 넘길 곳이 없으면 그 함수가 null(단추는 꺼진 채 남는다) · expanded = 크게 보기(목록 없이 넓게).
export default function DevRequestDetail({
  item, me = null, loading = false, error = '', onClose, onEdit, onChanged, fullScreen = false, width = 460,
  expanded = false, onToggleExpand, nav,
}) {
  // 상세 폭은 AX·비AX 같다(2판 V3 — 오른쪽 검토 칸이 없다).
  let shell;
  if (fullScreen) {
    shell = { position: 'fixed', inset: 0, zIndex: 50, background: COLORS.bg, overflowY: 'auto', overflowX: 'hidden' };
  } else if (expanded) {
    shell = { flex: 1, minWidth: 0, background: COLORS.bg, overflowY: 'auto', overflowX: 'hidden', height: '100%' };
  } else {
    shell = {
      width: `${width}px`, flexShrink: 0,
      borderLeft: `1px solid ${COLORS.border}`, background: COLORS.bg, overflowY: 'auto', overflowX: 'hidden', height: '100%',
    };
  }
  const masked = !!item?.masked;
  const isAx = me?.is_ax === true;
  // ②③ 를 그 자리에서 고친다 — AX 이고 철회되지 않은 요청만(서버 review 가 철회 건은 409).
  const canReview = isAx && !!item && !masked && item.withdrawn !== true;

  // 첨부 목록 — item 이 바뀔 때(고치기 저장 뒤 새 item) · 기타 첨부에서 올리거나 지운 뒤 다시 받는다. 가린 상세는 부르지 않는다(서버 403).
  //   같은 요청을 다시 받는 동안은 앞 목록을 그대로 둔다(묶음이 깜빡이지 않게).
  const [fileList, setFileList] = useState({ id: null, items: null, error: '' });
  const [filesVersion, setFilesVersion] = useState(0);
  const [fileError, setFileError] = useState('');
  const [viewer, setViewer] = useState(null);   // null | { file, url, owned }
  // 고치기 상태의 주인 — null | 'part2' | 'part3'. 답하기 창이 열렸는지(할 일 상자·추가 요청 기록이 같은 창을 연다).
  const [editing, setEditing] = useState(null);
  const [answerOpen, setAnswerOpen] = useState(false);
  const [todoBusy, setTodoBusy] = useState(false);
  const [todoError, setTodoError] = useState('');
  const dirtyRef = useRef(false);
  const viewerRef = useRef(null);
  viewerRef.current = viewer;
  // 키보드(J/K) 리스너는 «넘길 곳이 있나»가 바뀔 때만 다시 건다 — 지금 값은 ref 로 읽는다.
  const navRef = useRef(nav);
  navRef.current = nav;
  const editingRef = useRef(null);
  const goRef = useRef(null);
  const returnFocusRef = useRef(null);
  const aliveRef = useRef(true);
  const itemId = item ? item.id : null;

  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
      if (viewerRef.current?.owned) dropUrl(viewerRef.current.url);
    };
  }, []);

  // 다른 요청을 열면 고치던 카드·답하기 창은 닫는다.
  useEffect(() => {
    setEditing(null);
    setAnswerOpen(false);
    setTodoError('');
    dirtyRef.current = false;
  }, [itemId]);

  useEffect(() => {
    setFileError('');
    if (!item || masked) {
      setFileList({ id: null, items: null, error: '' });
      return undefined;
    }
    const id = item.id;
    let alive = true;
    setFileList((prev) => (prev.id === id ? { ...prev, error: '' } : { id, items: null, error: '' }));
    devreqAPI.files(id)
      .then((r) => { if (alive) setFileList({ id, items: Array.isArray(r?.data) ? r.data : [], error: '' }); })
      .catch(async (err) => {
        const message = await errorText(err, FILES_LOAD_FAILED);
        if (alive) setFileList((prev) => ({ id, items: prev.id === id ? prev.items : null, error: message }));
      });
    return () => { alive = false; };
  }, [item, filesVersion]);

  const allFiles = item && fileList.id === item.id ? fileList.items : null;
  const filesOf = (name) => (allFiles || []).filter((f) => f.field === name);
  const otherFiles = allFiles === null ? null : allFiles.filter((f) => !f.field);
  // 썸네일 — 칸 첨부와 추가 요청 답 첨부(ask_answer).
  const thumbs = useFileThumbs((allFiles || []).filter((f) => FIELD_FILE_NAMES.includes(f.field) || f.field === 'ask_answer'));
  // 추가 요청 답 첨부 — ask_id 로 묶는다(추가 요청 기록·답하기 창 몫).
  const filesByAsk = {};
  (allFiles || []).forEach((f) => {
    if (f.ask_id === null || f.ask_id === undefined) return;
    if (!filesByAsk[f.ask_id]) filesByAsk[f.ask_id] = [];
    filesByAsk[f.ask_id].push(f);
  });

  const filesChanged = () => {
    setFilesVersion((v) => v + 1);
    onChanged?.();
  };
  // 고치기 창 — 상세가 이미 받은 썸네일을 함께 넘긴다(창이 같은 그림을 또 내려받지 않게).
  const openEdit = () => onEdit?.({ thumbs });
  const downloadFile = async (file) => {
    setFileError('');
    try {
      await saveDevreqFile(file);
    } catch (err) {
      const message = await errorText(err, FILE_DOWNLOAD_FAILED);
      if (aliveRef.current) setFileError(message);
    }
  };
  // 크게 보기 — 썸네일이 있으면 그 주소로 · 없으면(2MB 초과 등) 그때 받아서 연다(그 주소는 닫을 때 revoke).
  const openViewer = async (file, trigger) => {
    returnFocusRef.current = trigger || null;
    setFileError('');
    const cached = thumbs[file.id];
    if (cached) {
      setViewer({ file, url: cached, owned: false });
      return;
    }
    try {
      const r = await devreqAPI.download(file.id);
      const url = makeUrl(r?.data);
      if (!url) throw new Error('no url');
      if (!aliveRef.current) {
        dropUrl(url);
        return;
      }
      setViewer({ file, url, owned: true });
    } catch (err) {
      const message = await errorText(err, FILE_DOWNLOAD_FAILED);
      if (aliveRef.current) setFileError(message);
    }
  };
  const closeViewer = () => {
    const current = viewerRef.current;
    setViewer(null);
    if (current?.owned) dropUrl(current.url);
    returnFocusRef.current?.focus?.();
  };
  // ① 의 글 칸 — 글 바로 아래에 그 칸 첨부(글은 dd 의 글자 그대로 · pre-wrap).
  const withFiles = (name, label, value) => (
    <>
      {text(value)}
      <FieldFiles label={label} files={filesOf(name)} thumbs={thumbs} onOpen={openViewer} onDownload={downloadFile} />
    </>
  );

  // ②③ 카드 고치기 — 다른 카드를 고치던 중이고 바뀐 칸이 있으면 버릴지 묻는다.
  const startEdit = async (part) => {
    if (editing === part) return;
    if (editing && dirtyRef.current && !(await confirmDialog(DISCARD_EDIT))) return;
    dirtyRef.current = false;
    setEditing(part);
  };
  const cancelEdit = () => {
    dirtyRef.current = false;
    setEditing(null);
  };
  // «이전 / 다음» — 고치던 카드에 바뀐 칸이 있으면 버릴지 묻는다(startEdit 와 같은 규칙·문구). 단추와 J/K 가 같이 쓴다.
  const go = async (fn) => {
    if (!fn) return;
    if (editing && dirtyRef.current && !(await confirmDialog(DISCARD_EDIT))) return;
    if (!aliveRef.current) return;
    dirtyRef.current = false;
    setEditing(null);
    fn();
  };
  editingRef.current = editing;
  goRef.current = go;
  // J = 다음 · K = 이전 — 넘길 곳이 하나라도 있을 때만 window 에 하나 건다. 입력 칸·창 안·열린 모달·고치는 중·
  //   조합키·한글 조합 중·누르고 있는 반복은 무시한다. ↑/↓ 는 상세 스크롤 키라 쓰지 않는다.
  const navKeysOn = !!(nav && (nav.onPrev || nav.onNext));
  useEffect(() => {
    if (!navKeysOn) return undefined;
    const onKey = (event) => {
      const dir = navKeyDir(event);
      if (!dir) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.isComposing || event.repeat) return;
      const target = event.target;
      if (target && typeof target.closest === 'function'
        && (target.closest('input, textarea, select') || target.closest('[role="dialog"], [role="alertdialog"]'))) return;
      if (target && target.isContentEditable) return;
      if (document.querySelector(OPEN_MODAL)) return;
      if (editingRef.current !== null) return;
      const fn = dir > 0 ? navRef.current?.onNext : navRef.current?.onPrev;
      if (!fn) return;
      event.preventDefault();
      goRef.current(fn);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navKeysOn]);
  const reviewSaved = () => {
    dirtyRef.current = false;
    setEditing(null);
    onChanged?.();
  };
  // 완료 확인이 «수정 필요»면 바로 테스트로 되돌린다(완료에서 나가면 서버가 확인 칸을 비운다).
  const revertToTest = async () => {
    if (todoBusy || !item) return;
    setTodoBusy(true);
    setTodoError('');
    try {
      await devreqAPI.review(item.id, { status: '테스트' });
      if (aliveRef.current) onChanged?.();
    } catch (err) {
      const message = await errorText(err, REVIEW_SAVE_FAILED);
      if (aliveRef.current) setTodoError(message);
    } finally {
      if (aliveRef.current) setTodoBusy(false);
    }
  };
  const showAsks = () => {
    if (!item) return;
    document.getElementById(asksSectionId(item.id))?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  };

  // «할 일» — 요청자 쪽(can 으로 판정) 다음 AX 쪽(me.is_ax · 철회 건 제외)을 모아 맨 위 하나만 보인다.
  const todos = [];
  if (item && !masked) {
    const c = item.can || {};
    const asks = Array.isArray(item.asks) ? item.asks : [];
    const openAsk = openAskOf(item);
    if (c.answer_ask === true && openAsk) {
      todos.push({
        title: openAsk.by_ai === true ? ASKED_BY_AI : ASKED_BY_REVIEWER,
        body: openAsk.body,
        action: <button type="button" onClick={() => setAnswerOpen(true)} style={btn('primary', 'sm')}>답하기</button>,
      });
    }
    if (c.confirm === true && !item.confirm_state) {
      todos.push({ title: '써 보시고 «③ 진행·완료» 아래에서 «확인» 또는 «수정 필요»로 알려 주세요' });
    }
    // AX 에게는 서버가 edit_part1 을 늘 참으로 준다 — 이 항목은 요청자에게만.
    if (item.status === '접수' && c.edit_part1 === true && !isAx) {
      todos.push({
        title: '접수 기간 안에는 내용을 고칠 수 있어요',
        action: <button type="button" onClick={openEdit} style={btn('accent', 'sm')}>내용 고치기</button>,
      });
    }
    if (isAx && item.withdrawn !== true) {
      if (item.confirm_state === '수정 필요' && item.status === '완료') {
        todos.push({
          title: item.confirm_note ? `요청자가 수정 필요로 답했어요: ${item.confirm_note}` : '요청자가 수정 필요로 답했어요',
          action: <button type="button" onClick={revertToTest} disabled={todoBusy} style={btn('danger', 'sm')}>테스트로 되돌리기</button>,
        });
      }
      const lastAsk = asks[asks.length - 1];
      if (lastAsk && lastAsk.state === 'answered' && !axActedAfter(item.events, lastAsk.answered_at)) {
        todos.push({
          title: '요청자가 추가 요청에 답했어요',
          body: excerpt(lastAsk.answer),
          action: <button type="button" onClick={showAsks} style={btn('secondary', 'sm')}>추가 요청 기록 보기</button>,
        });
      }
      if (!item.decision) {
        todos.push({
          title: '진행 여부를 정해 주세요',
          action: <button type="button" onClick={() => startEdit('part2')} style={btn('primary', 'sm')}>검토 시작</button>,
        });
      }
    }
  }
  const todo = todos[0] || null;

  // ② 검토 — AX 는 모든 칸(빈 칸은 —) · 요청자는 값 있는 칸만(상세 요구사항은 AX 만) · 다 비면 «아직 검토 전이에요».
  //   AX 담당자 줄도 같다(요청자는 정해졌을 때만 — 담당자만 있어도 «아직 검토 전»은 뜨지 않는다).
  const decisionCell = item?.decision ? <span style={decisionBadge(item.decision)}>{item.decision}</span> : EMPTY;
  // AI 1차 판독(AX 만 · 서버도 AX 가 아니면 null) — 판독 값이 있을 때만 ② 맨 위 줄 · 정했거나 철회한 요청의 주의 상태는 회색 글자.
  const aiView = item && isAx ? aiScreenView(item) : null;
  const aiCell = aiView && (
    <>
      {aiView.muted
        ? <span style={{ color: COLORS.textSub }}>{aiView.label}</span>
        : <span style={smallBadge(...aiView.colors)}>{aiView.label}</span>}
      {has(item.ai_screen_note) && <div style={{ marginTop: '4px' }}>{item.ai_screen_note}</div>}
    </>
  );
  const part2Rows = !item ? [] : (isAx
    ? [
      aiView && ['AI 1차 판독', aiCell],
      ['진행 여부', decisionCell],
      ['사유', text(item.decision_reason)],
      ['우선순위', text(item.priority)],
      ['예정 시작', fmtDay(item.plan_start)],
      ['예정 완료', fmtDay(item.plan_end)],
      ['상세 요구사항', text(item.detail_state)],
      ['AX 담당자', text(item.assignee_name)],
    ].filter(Boolean)
    : [
      has(item.decision) && ['진행 여부', decisionCell],
      has(item.decision_reason) && ['사유', text(item.decision_reason)],
      has(item.priority) && ['우선순위', text(item.priority)],
      has(item.plan_start) && ['예정 시작', fmtDay(item.plan_start)],
      has(item.plan_end) && ['예정 완료', fmtDay(item.plan_end)],
      has(item.assignee_name) && ['AX 담당자', text(item.assignee_name)],
    ].filter(Boolean));
  // ③ 진행·완료 — 요청자에게는 값 있는 줄만(상태는 늘 있다).
  const confirmCell = item?.confirm_note ? `${text(item.confirm_state)}\n${item.confirm_note}` : text(item?.confirm_state);
  const part3Rows = !item ? [] : [
    ['상태', item.status ? <span style={statusBadge(item.status)}>{item.status}</span> : EMPTY],
    (isAx || has(item.done_on)) && ['완료일', fmtDay(item.done_on)],
    (isAx || has(item.usage_location)) && ['사용 위치', <UsageLocation value={item.usage_location} />],
    (isAx || has(item.confirm_state)) && ['요청자 확인', confirmCell],
  ].filter(Boolean);
  const editButton = (part, label) => (
    <button type="button" aria-label={label} onClick={() => startEdit(part)} disabled={editing === part}
      style={{ ...btn('secondary', 'sm'), opacity: editing === part ? 0.5 : 1 }}>고치기</button>
  );
  const editingPart2 = canReview && editing === 'part2';
  const editingPart3 = canReview && editing === 'part3';

  return (
    <>
    <aside aria-label="요청 상세" style={{ ...shell, boxSizing: 'border-box', padding: '16px' }}>
      {/* 읽기 폭 — 🔴 이 감싸기는 늘 그리고 스타일 값만 바꾼다(넣었다 뺐다 하면 아래 자식이 새로 만들어져 고치던 값·초점이 사라진다). */}
      <div style={{ maxWidth: expanded ? READ_MAX_W : 'none', margin: expanded ? '0 auto' : 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
        <h2 style={{ margin: 0, fontSize: '17px', overflowWrap: 'anywhere' }}>{item ? text(item.req_no) : '요청 상세'}</h2>
        {item?.visibility === 'private' && <span style={smallBadge(COLORS.dangerSoft, COLORS.dangerText)}>비공개</span>}
        {item?.carried && (
          <span style={smallBadge(COLORS.warnSoft, COLORS.warn)}>이월({text(item.carried_from_round_no)}회차)</span>
        )}
        {item?.withdrawn && <span style={smallBadge('#f3f4f6', COLORS.textSub)}>철회</span>}
        {(nav || onToggleExpand || onClose) && (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '6px' }}>
            {nav && (
              <>
                <button type="button" aria-label="이전 요청" title="이전 요청 (K)" onClick={() => go(nav.onPrev)} disabled={!nav.onPrev}
                  style={{ ...btn('secondary', 'sm'), opacity: nav.onPrev ? 1 : 0.5 }}>‹ 이전</button>
                {nav.label && <span style={{ fontSize: '12px', color: COLORS.textSub, whiteSpace: 'nowrap' }}>{nav.label}</span>}
                <button type="button" aria-label="다음 요청" title="다음 요청 (J)" onClick={() => go(nav.onNext)} disabled={!nav.onNext}
                  style={{ ...btn('secondary', 'sm'), opacity: nav.onNext ? 1 : 0.5 }}>다음 ›</button>
              </>
            )}
            {/* 같은 단추 하나에서 글자만 바꾼다(누른 뒤에도 초점이 그대로). */}
            {onToggleExpand && (
              <button type="button" onClick={onToggleExpand} style={btn('secondary', 'sm')}>{expanded ? '목록 함께 보기' : '크게 보기'}</button>
            )}
            {onClose && <button type="button" onClick={onClose} style={btn('secondary', 'sm')}>닫기</button>}
          </div>
        )}
      </div>

      {loading && <div role="status" style={{ color: COLORS.textMuted, fontSize: '13px' }}>불러오는 중…</div>}
      {error && <div role="alert" style={{ padding: '10px 12px', borderRadius: '8px', background: COLORS.dangerSoft, color: COLORS.dangerText, fontSize: '13px' }}>{error}</div>}

      {item && !masked && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <StageBar item={item} compact={fullScreen} />
          {item.withdrawn !== true && HOLD_DECISIONS.includes(item.decision) && (
            <span style={decisionBadge(item.decision)}>{item.decision}</span>
          )}
          <div style={{ marginLeft: 'auto' }}>
            <DevRequestAskControls key={`ask-${item.id}`} item={item} me={me} onChanged={onChanged} />
          </div>
        </div>
      )}
      {item && !masked && <TodoBox todo={todo} error={todoError} />}
      {item && !masked && isAx && <DevRequestQaAccount key={`qa-${item.id}`} item={item} onChanged={onChanged} />}

      {item && <DevRequestActions key={`actions-${item.id}`} can={item.can} requestId={item.id} onEdit={openEdit} onChanged={onChanged} />}

      {item && masked && (
        <>
          <p style={{ margin: '0 0 12px', padding: '10px 12px', borderRadius: '8px', background: '#f3f4f6', color: COLORS.textSub, fontSize: '13px' }}>
            🔒 {MASKED_NOTICE}
          </p>
          <section aria-label="보이는 칸" style={{ border: `1px solid ${COLORS.border}`, borderRadius: '10px', background: COLORS.surface, marginBottom: '12px' }}>
            <Fields rows={[
              ['요청번호', text(item.req_no)],
              ['부서', text(item.dept_name)],
              ['진행 여부', item.decision ? <span style={decisionBadge(item.decision)}>{item.decision}</span> : EMPTY],
              ['우선순위', text(item.priority)],
              ['예정 완료', fmtDay(item.plan_end)],
              ['상태', item.status ? <span style={statusBadge(item.status)}>{item.status}</span> : EMPTY],
            ]} />
          </section>
        </>
      )}

      {item && !masked && (
        <>
          <Part tone="part1" title="① 부서 작성"
            actions={isAx ? <DevRequestPart1Tools key={`part1-${item.id}`} item={item} onChanged={onChanged} /> : null}
            rows={[
              ['요청번호', text(item.req_no)],
              ['회차', item.round_no !== null && item.round_no !== undefined ? `${item.round_no}회차` : EMPTY],
              ['부서', text(item.dept_name)],
              ['요청자', text(item.requester_name)],
              ['요청일', fmtDay(item.requested_on)],
              ['부서 내 순위', text(item.dept_rank)],
              ['제목', text(item.title)],
              ['지금 하는 방식', withFiles('current_way', '지금 하는 방식', item.current_way)],
              ['원하는 기능', withFiles('wanted_feature', '원하는 기능', item.wanted_feature)],
              ['사용 대상·빈도', text(item.target_users)],
              ['참고자료', withFiles('reference_note', '참고자료', item.reference_note)],
            ]}>
            {fileError && (
              <div role="alert" style={{ margin: '0 14px 12px', fontSize: '12px', color: COLORS.dangerText }}>{fileError}</div>
            )}
          </Part>
          <Part tone="part2" title="② 검토" rows={editingPart2 ? null : part2Rows}
            actions={canReview ? editButton('part2', '② 검토 고치기') : null}>
            {isAx && item.withdrawn === true && (
              <div role="note" style={{ margin: '0 14px 12px', padding: '8px 12px', borderRadius: '8px', background: '#f3f4f6', color: COLORS.textSub, fontSize: '13px' }}>
                {WITHDRAWN_NOTICE}
              </div>
            )}
            {!isAx && part2Rows.length === 0 && (
              <p style={{ margin: 0, padding: '12px 14px', fontSize: '13px', color: COLORS.textSub }}>{NOT_REVIEWED}</p>
            )}
            {/* 고치는 중에도 같은 자리(담당자 상자는 숨고 입력 칸 바로 위) — 자리가 같아 다시 마운트·다시 부르기가 없다. */}
            {isAx && !masked && <DevRequestAiReport key={`ai-report-${item.id}`} item={item} />}
            {canReview && !editingPart2 && (
              <DevRequestAssignee key={`assignee-${item.id}`} item={item} onChanged={onChanged} />
            )}
            {editingPart2 && (
              <DevRequestReviewPanel item={item} part="part2" onSaved={reviewSaved} onCancel={cancelEdit} dirtyRef={dirtyRef} />
            )}
          </Part>
          <Part tone="part3" title="③ 진행·완료" rows={editingPart3 ? null : part3Rows}
            actions={canReview ? editButton('part3', '③ 진행·완료 고치기') : null}>
            {editingPart3 && (
              <DevRequestReviewPanel item={item} part="part3" onSaved={reviewSaved} onCancel={cancelEdit} dirtyRef={dirtyRef} />
            )}
            {item.can?.confirm === true && <ConfirmBox key={`confirm-${item.id}`} item={item} onChanged={onChanged} />}
          </Part>
          <MergeInfo item={item} />
          <div style={{ fontSize: '12px', color: COLORS.textSub, marginBottom: '12px' }}>
            첨부 {text(item.file_count)} · 메모 {text(item.comment_count)}
          </div>
          {/* 첨부·추가 요청·메모 묶음은 전부 보는 사람에게만(가린 상세에는 없다). */}
          <DevRequestFiles
            key={`files-${item.id}`}
            requestId={item.id}
            canAttach={item.can?.attach === true}
            files={otherFiles}
            totalCount={allFiles ? allFiles.length : 0}
            loadError={fileList.id === item.id ? fileList.error : ''}
            onFilesChanged={filesChanged}
          />
          <DevRequestAsks
            key={`asks-${item.id}`}
            item={item}
            filesByAsk={filesByAsk}
            totalCount={allFiles ? allFiles.length : 0}
            thumbs={thumbs}
            onOpen={openViewer}
            onDownload={downloadFile}
            onFilesChanged={filesChanged}
            openEdit={openEdit}
            answerOpen={answerOpen}
            onAnswerOpen={setAnswerOpen}
            onChanged={onChanged}
          />
          <DevRequestComments
            key={`comments-${item.id}`}
            requestId={item.id}
            canComment={item.can?.comment === true}
            isAx={isAx}
            onChanged={onChanged}
          />
          <History events={item.events} />
        </>
      )}
      </div>
    </aside>
    {viewer && <ImageViewer file={viewer.file} url={viewer.url} onClose={closeViewer} />}
    </>
  );
}
